import { useAtomValue } from 'jotai';
import { selectAtom } from 'jotai/utils';
import { orgConfigState } from './business/useOrgConfig';

const pureLLMEnableState = selectAtom(
  orgConfigState,
  (config) => config?.whiteListConfig?.ENABLE_PURE_LLM_ORG ?? false,
);

export const usePureLLMEnable = () => {
  return useAtomValue(pureLLMEnableState);
};
